import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=736d8ac6&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=js&"
export * from "./MainTitle.vue?vue&type=script&lang=js&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=736d8ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d8ac6",
  null
  
)

export default component.exports